/* eslint-disable no-unused-vars */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable spaced-comment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import "./end-page.scss";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import ConfigurationSaved from "../../../Common/components/EndPage/ConfigurationSaved/ConfigurationSaved";
import ActionLinks from "../../../Common/components/EndPage/ActionLinks/ActionLinks";
import BillOfMaterials from "../../components/BillOfMaterials/BillOfMaterials";
import EditableConfigurationName from "../../../Common/components/EndPage/EditableConfigurationName/EditableConfigurationName";
import { getProductsDescriptions } from "../../../Common/utils/api/api";
import {
  selectConfigAxes,
  setProductsDescriptions,
  selectRetrofitConfiguration,
  resetRetrofit
} from "../../../Retrofit/store/slices/retrofit";
import Documentation from "../../../Common/components/EndPage/Documentation/Documentation";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import t from "../../../Common/utils/translation/translator";
import MsxIcons from "../../../Common/components/Icons/MsxIcons/MsxIcons";
import CorrespondingCountry from "../../components/CorrespondingCountry/CorrespondingCountry";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import { setFullScreen } from "../../../Common/store/slices/common";

// import InputField from "../../components/Inputs/InputField/InputField";
// import Button from "../../Common/components/Buttons/Button/Button";

const EndPage = ({ ...props }) => {
  const dispatch = useDispatch();
  const axes = useSelector(selectConfigAxes);
  const configuration = useSelector(selectRetrofitConfiguration);

  // get the list of motor, drive and gearbox references from axes in a single array
  const productsReferences = axes.reduce((acc, axis) => {
    const motorReference = axis.bundle?.motorReference;
    const driveReference = axis.bundle?.driveReference;
    const gearboxReference = axis.bundle?.gearboxReference;
    const adaptationKitReference = axis.bundle?.adaptationKitReference;
    if (motorReference) {
      acc.push(motorReference);
      const motorAccessories = axis.bundle?.bundleData?.motor?.accessories;
      if (motorAccessories) {
        motorAccessories
          .filter((access) => access.isSelected)
          .forEach((access) => acc.push(access.commercialReference));
      }
    }
    if (driveReference) {
      const driveAccessories = axis.bundle?.bundleData?.drive?.accessories;
      if (driveAccessories) {
        driveAccessories
          .filter((access) => access.isSelected)
          .forEach((access) => acc.push(access.commercialReference));
      }
    }
    if (gearboxReference) {
      acc.push(gearboxReference);
    }
    if (adaptationKitReference) {
      acc.push(adaptationKitReference);
    }
    return acc;
  }, []);

  // remove duplicates from productsReferences
  const productsReferencesUnique = [...new Set(productsReferences)];

  // Get Products Descriptions
  const {
    refetch: execGetProductsDescriptions
    // isFetching: isFetchingGetProductsDescriptions,
    // isLoading: isLoadingGetProductsDescriptions
  } = useQuery(
    "GET PRODUCTS DESCRIPTIONS : it's a Post method",
    async () => {
      try {
        const fetchedDescriptions = await getProductsDescriptions(productsReferencesUnique);
        // console.log("fetchedDescriptions", fetchedDescriptions);
        dispatch(setProductsDescriptions(fetchedDescriptions));
        return fetchedDescriptions;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useEffect(() => {
    execGetProductsDescriptions();
  }, []);

  const isMobile = useCheckMobileScreen();

  const [endPageCollapsibles, setEndPageCollapsibles] = useState([
    {
      id: 1,
      label: "Bill of materials",
      component: <BillOfMaterials />,
      active: false
    }
  ]);

  return (
    <div className="end-page bg-white" {...props}>
      <div className={isMobile ? "bg-white print:hidden" : "bg-white p-4 print:hidden"}>
        {!isMobile && (
          <div className=" gap-4 grid grid-cols-2">
            <div className="col-span-1 end-page-split-part with-margin space-y-4">
              <div className="text-lg flex items-center font-bold justify-between">
                <EditableConfigurationName />
                <CorrespondingCountry country={configuration.configData.country} />
              </div>
              <BillOfMaterials />
            </div>
            <div className="col-span-1 end-page-split-part flex flex-col space-y-4 border-l px-10">
              <ConfigurationSaved data-testid="configuration-saved" />
              <div className="flex flex-col gap-4">
                <ActionLinks />
                <Documentation referenceIds={productsReferencesUnique} />
              </div>
            </div>
          </div>
        )}

        {isMobile && (
          <div className="bg-white mobile-version grid grid-cols-1 gap-4 md:hidden mb-4 md:mb-4">
            <div className="text-lg flex items-center font-bold justify-between -mb-6 mt-1">
              <EditableConfigurationName />
              <CorrespondingCountry country={configuration.configData.country} />
            </div>
            <ConfigurationSaved data-testid="configuration-saved-mobile" />
            <div className="collapsibles flex flex-col gap-3">
              {endPageCollapsibles.map((collapsible) => (
                <div key={collapsible.id} className="collapsible">
                  <div
                    className={`collapsible-header rounded-sm text-gray-600 text-sm p-2.5
                    cursor-pointer flex items-center justify-between transition-all duration-100 border-[1px] border-gray-200 bg-gray-5
                    ${collapsible.active ? "" : ""}`}
                    onClick={
                      () =>
                        setEndPageCollapsibles((prev) =>
                          prev.map((item) => {
                            if (item.id === collapsible.id) {
                              return {
                                ...item,
                                active: !item.active
                              };
                            }
                            return item;
                          })
                        )
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  >
                    <div className="ml-2.5 text-base text-gray-500">{collapsible.label}</div>
                    <MsxIcons
                      className={`transition-all duration-100${collapsible.active ? "rotate-180" : ""}`}
                      name="arrow-down"
                      size="nano"
                    />
                  </div>
                  <div
                    className={`collapsible-content transition-all duration-100
                  ${collapsible.active ? "p-[0.25rem]" : "h-0 overflow-hidden"}`}
                  >
                    {collapsible.component}
                  </div>
                </div>
              ))}
            </div>
            <ActionLinks />
            <Documentation referenceIds={productsReferencesUnique} />
          </div>
        )}
      </div>
      <Navigator
        continueLabel={t("msizer.ui.footer.go_to_start_page")}
        continueAction={() => {
          dispatch(resetRetrofit());
          dispatch(setFullScreen(false));
        }}
      />
    </div>
  );
};

export default EndPage;
